module.exports = __webpack_public_path__ + "img/air1.90b351f5.jpg";